import React from "react";
import { RCCButton, RCCGrid, RCCTextArea, RCCTooltip } from "react-common-components";
import { Control, FieldErrors, FieldValues, UseFormWatch } from "react-hook-form";
import { useTranslation } from "src/context/Translations/context";
import Select from "src/components/Select";
import RadioSwitchSwot from "src/pages/Analysis/Panel/Components/radioSwitchSwot";
import Audit from "src/components/Audit";
import swotLabels from "../../SWOT/SwotLabels";
import { IMatba001Form, IMatba004 } from "../interface";

export interface ILevel3Change{
	analysisData: IMatba001Form;
	index: number;
	item: IMatba004;
	register: (RegisterOptions?: any) => void;
    control: Control<FieldValues>;
    errors: FieldErrors<FieldValues>;
	watch: UseFormWatch<FieldValues>;
    saveItem: (index: number) => void;
    changeItem: (row:IMatba004, change: boolean) => void;
    deleteItem: (row:IMatba004, useRequest:boolean) => void;
}

const Level3Change: React.FC<ILevel3Change> = ({
	analysisData,
	item,
	index,
	register,
	control,
	errors,
	watch,
	saveItem,
	changeItem,
	deleteItem
}) => {
	const { translate } = useTranslation();
	const {importance,intensity,tendencyAnalysis} = swotLabels(translate);	

	const changeRadioSwitchSwot = (row:IMatba004, change: boolean) => {
		
		const newItem ={
			...row,
			maa004Descricao: watch(`[${index}].maa004Descricao`),
			maa004Probabilidade: watch(`[${index}].maa004Probabilidade`),
			maa004Importancia: watch(`[${index}].maa004Importancia`),
			maa004Tendencia: watch(`[${index}].maa004Tendencia`),
			maa004Comentario: watch(`[${index}].maa004Comentario`)
		};

		changeItem(newItem, change);
	};

	return(
		<>
			<RCCGrid container> 
				<RCCGrid 
					container
					item
					xs={12}
					sm={12}
					alignItems="flex-end"
					justify="flex-end"
				>
					<Audit data={item} type="pop"/>
				</RCCGrid>
				<RCCGrid 
					container
					item
					spacing={1}
				>
					
					<RCCGrid item container
						xs={analysisData.maa001Gut === "S" ? 2 : 5}
					>
						<RCCGrid container item
							xs={10}
						>
							<input 
								{...register(`[${index}].id`)} 
								name={`[${index}].id`}
								defaultValue={item.id}
								type="hidden"
							/>
							<input 
								{...register(`[${index}].maa004Id`)} 
								name={`[${index}].maa004Id`}
								defaultValue={item.maa004Id}
								type="hidden"
							/>

							<input 
								{...register(`[${index}].maa004Maa003Id`)} 
								name={`[${index}].maa004Maa003Id`}
								defaultValue={item.maa004Maa003Id}
								type="hidden"
							/>
											
							<RCCTextArea
								name={`[${index}].maa004Descricao`}
								register={register}
								label={translate("Descrição")}
								error={errors.maa004Descricao}
								maxLength={200}
								defaultValue={item.maa004Descricao}
								required
							/>
						</RCCGrid>
					</RCCGrid>
					{
						analysisData.hasSwot &&
						<RCCGrid item container
							md={analysisData.maa001Gut === "S" ? 2 : 6}
							direction="row"
						>
							<RadioSwitchSwot 
								register={register}
								analysisData={analysisData}
								index={index}
								item={item}
								changeItem={changeRadioSwitchSwot}
							/>
						</RCCGrid>
					}
					{
						analysisData.maa001Gut === "S" &&
                        <RCCGrid item container xs={6} spacing={1}>
                        	<RCCGrid item container
                        		xs={12}
                        		sm={4}
                        	>
                        		<Select 
                        			control={control}
                        			name={`[${index}].maa004Importancia`}
                        			options={importance}
                        			label={translate("Importância")}
                        			defaultValue={item.maa004Importancia.toString()}
                        		/>
                        	</RCCGrid>
                        	<RCCGrid item container
                        		xs={12}
                        		sm={4}
                        	>
                        		<Select 
                        			control={control}
                        			name={`[${index}].maa004Probabilidade`}
                        			options={intensity} 
                        			label={translate("Intensidade") }
                        			defaultValue={item.maa004Probabilidade.toString()}
                        		/>
                        	</RCCGrid>
                        	<RCCGrid item container
                        		xs={8}
                        		sm={4}
                        	>
                        		<Select 
                        			control={control}
                        			name={`[${index}].maa004Tendencia`}
                        			options={tendencyAnalysis}
                        			label={translate("Tendência")}
                        			defaultValue={item.maa004Tendencia.toString()}
                        		/>
                        	</RCCGrid>
                        </RCCGrid>
					}
				</RCCGrid>
				<RCCGrid 
					alignContent="flex-end"
					alignItems="baseline"
					container 
					item
					xs={12}
				>
					<RCCGrid container item xs={10}>
						<RCCTextArea
							name={`[${index}].maa004Comentario`}
							register={register}
							label={translate("Comentário")}
							error={errors.maa004Comentario}
							maxLength={200}
							defaultValue={item.maa004Comentario}
						/>
					</RCCGrid>

					<RCCGrid container item xs={2} justifyContent="flex-end">
						<RCCTooltip
							text={translate("Cancelar")}
							color="red">
							<RCCButton 
								onClick={() => (
									item.maa004Id === 0 ? 
										deleteItem(item, false) 
										: 
										changeItem(item, false)
								)} 
								size="sm" 
								icon={{name:"close",strokeWidth:2}}
								color="red" 
								layout="isRounded"
							/>
						</RCCTooltip>
											
						<RCCTooltip
							text={translate("Ok")}
							color="green">
							<RCCButton 
								onClick={() => {
									saveItem(index);
								}} 
								size="sm" 
								color="green" 
								icon={{name:"check"}} 
								layout="isRounded"
							/>
						</RCCTooltip>
					</RCCGrid>
					
				</RCCGrid>
			</RCCGrid>
		</>
	);
};

export default Level3Change;
